import { Segment, SegmentFilter } from '../../segment-controls.types';
import Pill from 'common/components/pills/pill';
import { PillTheme } from 'common/components/pills/pill-theme';
import SegmentFilterPill from './segment-filter-pill';

function getFiltersBySegment(
  segmentId: string,
  segmentFilters: SegmentFilter[]
): SegmentFilter[] {
  const currentSegmentFilters = segmentFilters.filter(
    (filter) => filter.segmentId === segmentId
  );

  return currentSegmentFilters;
}

interface SegmentControlFiltersProps {
  componentId: string;
  segment: Segment;
  segmentFilters: SegmentFilter[];
}

const SegmentFilters = ({
  componentId,
  segment,
  segmentFilters
}: SegmentControlFiltersProps) => {
  return (
    <div className="flex flex-wrap items-center">
      {getFiltersBySegment(segment.id, segmentFilters).map(
        (filter, filterIndex) => (
          <div
            key={`filter-segment-${segment.id}-${filter.id}`}
            className="mr-2 flex"
          >
            {filterIndex !== 0 ? (
              <div className="text-sm flex items-center mr-2">
                <Pill theme={PillTheme.DISABLED}>
                  <span className="uppercase p-2">AND</span>
                </Pill>
              </div>
            ) : (
              <></>
            )}
            <SegmentFilterPill componentId={componentId} filter={filter} />
          </div>
        )
      )}
    </div>
  );
};

export default SegmentFilters;
